package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.layouts.PageLayout
import com.arena_web.ui.sections.info.InfoBullet
import com.arena_web.ui.sections.info.InfoPageScaffold
import com.arena_web.ui.sections.info.InfoParagraph
import com.arena_web.ui.sections.info.InfoSection
import com.varabyte.kobweb.core.Page

@Page("/refund")
@Composable
fun RefundPage() {
    PageLayout(
        title = "Refund Policy",
        description = "Refund and cancellation policy for purchases on Arena Pro Play.",
        mobileReady = true,
    ) {
        InfoPageScaffold(title = "Refund Policy") {
            InfoSection("1. What this policy covers") {
                InfoParagraph(
                    "This policy applies to the Arena Access subscription purchased on arenaproplay.com. Arena Access " +
                        "is a recurring subscription that unlocks premium features inside Arena Pro Play such as " +
                        "AI-generated player card avatars, Pro events and all player card designs. The subscription " +
                        "has no monetary value outside the service and cannot be cashed out, transferred between " +
                        "users, traded, or exchanged."
                )
            }
            InfoSection("2. Digital content and immediate delivery") {
                InfoParagraph(
                    "Access is granted to your account immediately after a successful payment. By subscribing you " +
                        "request immediate delivery of this digital content and acknowledge that, where the law " +
                        "provides a statutory withdrawal period for online purchases, you lose the right of " +
                        "withdrawal once access has been granted and you start using it."
                )
            }
            InfoSection("3. Cancelling your subscription") {
                InfoBullet("You can cancel at any time from the app; you keep access until the end of the paid period.")
                InfoBullet("Cancelling stops future renewals — you are not charged again after the current period ends.")
                InfoBullet(
                    "Where a refund of a charge is due, it is issued to the original payment method, normally " +
                        "within 14 days of approval."
                )
            }
            InfoSection("4. When a refund is not available") {
                InfoBullet("The premium features unlocked by the subscription have already been used in the app.")
                InfoBullet("More than 14 days have passed since the charge, unless applicable law says otherwise.")
                InfoBullet(
                    "The account associated with the subscription was terminated for a violation of our Terms of Service."
                )
            }
            InfoSection("5. Incorrect or duplicate charges") {
                InfoParagraph(
                    "If you were charged but access was not granted, were charged twice for one period, or believe a " +
                        "charge is otherwise incorrect, contact us and we will investigate and refund or restore " +
                        "access as appropriate. Please include the order reference from your payment receipt and the " +
                        "email associated with your Arena account."
                )
            }
            InfoSection("6. Purchases in the mobile app") {
                InfoParagraph(
                    "Subscriptions purchased in our iOS or Android apps are processed by the Apple App Store or " +
                        "Google Play. Refunds and cancellations for those purchases are handled by the respective " +
                        "store under its own policy, and we cannot issue them directly."
                )
            }
            InfoSection("7. How to request a refund") {
                InfoParagraph(
                    "Contact us through the Supports link in the footer with your order reference and account " +
                        "email. We reply to refund requests within a few business days. Nothing in this policy " +
                        "limits any rights you have under mandatory consumer protection law in your country."
                )
            }
        }
    }
}
